import Header from "../Navigation/Header";
export default function AboutUs() {
	return (
		<>
			<Header />
			<div id="page">
				<div className="page-inner">
					<div id="main">
						<div className="about">
							<h1 style={{ marginTop: "0" }}>About Us</h1>
							<p>Information for this database is compiled through literature and media searches of economically motivated and intentional adulteration incidents in food products since 1980. Sources include: FDA Consumer and FDA recall records, state reports, Google, the E.U. Rapid Alert System for Food and Feed (RASFF) portal, other international databases and <a href="https://www.fides-ids.com/" target="_blank" rel="noreferrer" >FIDES</a>, iDecisionSciences’ machine learning application. An incident is defined as a documented, isolated occurrence of adulteration in a single food product or group of associated food products occurring within a defined time frame and with a distinct group of perpetrators. Incidents that are difficult to isolate to a specific time frame and/or group of perpetrators, or with characteristics common to multiple perpetrators, are entered as a single incident. Melamine adulteration of dairy products in China in 2007-2008 is one example.</p>
							<p>Incidents which occurred ten years prior to the current calendar year are available to all users. Access to the most recent 10 years of events requires a subscription. For subscription information, please contact info@idecisionsciences.com</p>
							<h1>iDecisionSciences (IDS)</h1>
							<p>Established in 2009, the company has managed confidential supply chain data and provided software and professional services on behalf of the food industry. Led by an experienced team of professionals with more than sixty combined years in the food industry, the team works to identify and understand client vulnerabilities and develop actionable plans. IDS strives to enable clients to have a better understanding of their vulnerabilities and provide them with the information and tools they need for clear direction and effective solutions.</p>
							<h3 style={{ marginTop: "-20px" }}>
								Visit IDS:
								<a href="https://www.idecisionsciences.com/" target="_blank" rel="noreferrer" >www.idecisionsciences.com</a>
							</h3>
							<h1 style={{ marginTop: "40px" }}>Connect with IDS</h1>
							<ul className="connect-social clearfix">
								<li>
									<a href="https://twitter.com/iDecisionSci" target="_blank" rel="noreferrer" >
										<span className="fa fa-x-twitter"></span>
									</a>
								</li>
								<li>
									<a href="mailto:info@idecisionsciences.com" target="_blank" rel="noreferrer" >
										<span className="fa fa-envelope"></span>
									</a>
								</li>
							</ul>
						</div>
					</div>
				</div>
			</div>
		</>
	);
}
